export const POSITION_VALUES = [
    { label: 'Top', value: 'top' },
    { label: 'Bottom', value: 'bottom' },
]

export const INITIAL_NOTE = {
    type: 'text',
    title: '',
    position: 'top',
    value: '',
}
